import React from 'react';
import { FiShield, FiTool, FiBook, FiTarget } from 'react-icons/fi';
import Reveal from '../../fx/Reveal';
import CascadeGrid from '../../fx/CascadeGrid';

const services = [
    {
        icon: <FiTool size={26} />,
        title: 'Jeopardy & Attack-Defense CTFs',
        description: 'Immersive Capture The Flag environments that sharpen offensive and defensive cybersecurity skills.',
        items: ['Real-world CTF challenges', 'Red & Blue team scenarios', 'Customizable lab environments', 'Boot2Root & forensics tracks'],
    },
    {
        icon: <FiShield size={26} />,
        title: 'Table Top Exercises',
        description: 'Strategic simulations for leadership and IT to test decision-making under realistic cyber-crisis pressure.',
        items: ['Custom crisis scenarios', 'Executive-level engagement', 'Incident response playbooks', 'Post-mortem analysis & review'],
    },
    {
        icon: <FiBook size={26} />,
        title: 'Incident Handling Training',
        description: 'End-to-end training on identifying, analyzing, and mitigating real incidents with real tools.',
        items: ['Log analysis & threat hunting', 'SIEM tools & use-cases', 'Hands-on breach simulations', 'Playbook development'],
    },
    {
        icon: <FiTarget size={26} />,
        title: 'Boot2Root Challenges',
        description: 'Gamified penetration testing labs to exploit vulnerabilities and gain root access end to end.',
        items: ['Beginner to advanced machines', 'Linux & Windows targets', 'In-browser exploitation labs', 'Progress tracking & leaderboards'],
    },
];

const OurTraining = () => {
    return (
        <section id="services" className="relative bg-[#08090f] text-white px-6 md:px-16 py-24 overflow-hidden">
            <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto">
                <Reveal className="text-center mb-14">
                    <span className="pill tag inline-flex mb-4">PROGRAMS</span>
                    <h2 className="font-display text-4xl md:text-5xl font-bold">
                        Our <span className="text-gradient-red">training tracks</span>
                    </h2>
                    <p className="text-gray-400 max-w-2xl mx-auto mt-3 text-lg">
                        Industry-grade, scenario-based programs, fully customizable to your organization.
                    </p>
                </Reveal>

                <CascadeGrid className="grid gap-6 md:grid-cols-2 lg:grid-cols-4" stagger={110}>
                    {services.map((s, i) => (
                        <div key={i} className="card p-6 h-full">
                            <div className="w-12 h-12 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center text-red-400 mb-4">
                                {s.icon}
                            </div>
                            <h3 className="font-display text-lg font-semibold mb-2">{s.title}</h3>
                            <p className="text-gray-400 text-sm mb-4 leading-relaxed">{s.description}</p>
                            <ul className="text-sm text-gray-300 space-y-2">
                                {s.items.map((it, j) => (
                                    <li key={j} className="flex items-start gap-2">
                                        <span className="text-red-500 mt-1">▸</span>
                                        <span>{it}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </CascadeGrid>
            </div>
        </section>
    );
};

export default OurTraining;
